import React, { useState } from "react";
import { MuiTelInput } from "mui-tel-input";

const PhoneNumberInput = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (newValue: string | undefined) => void;
}) => {
  const [phoneNumber, setPhoneNumber] = useState(value || "");

  const handleChange = (newValue: string | undefined) => {
    if (newValue) {
      setPhoneNumber(newValue);
      if (onChange) {
        onChange(newValue);
      }
    }
  };

  return (
    <MuiTelInput
      fullWidth
      value={phoneNumber}
      onChange={handleChange}
      defaultCountry="GB"
    />
  );
};

export default PhoneNumberInput;
